import { combineReducers } from 'redux';

import { searchQueryReducer } from './query/searchQuery.reducer';

export const searchReducer = combineReducers({
  query: searchQueryReducer,
});
